import React from "react";

import withAuth from "../../../hoc/withAuth";
import MainLayout from "../../../components/layouts/MainLayout";

import { miscservices } from "../../../services/MiscServices";

import { DatePicker, Input, Button, Table, Form, Col, Row, Modal, Select } from "antd";
import dayjs from "dayjs";

const { Option } = Select;

// Fungsi ambil file JSON dari S3 (kamu bisa impor dari modul lain)

class LogAnalizedNoticeViewer extends React.Component {
  constructor(props) {
    super(props);

    const { match } = this.props;
    const code_svb = match.params.code_svb;

    this.state = {
      loadingButton: false,
      filterCodeSvb: code_svb,
      filterDate: null,
      filterEngineNumber: "",
      filterDocumentType: "VEHICLETAXNOTICE",
      dataLog: [],
    };
  }

  handleDateChange = (date) => {
    this.setState({ filterDate: date });
  };

  handleEngineChange = (e) => {
    this.setState({ filterEngineNumber: e.target.value });
  };

  handleDocumentTypeChange = (value) => {
    this.setState({ filterDocumentType: value });
  };

  fetchDataLog = async () => {
    try {
      const { filterCodeSvb, filterDocumentType, filterDate, filterEngineNumber } = this.state;

      if (!filterDate) {
        throw new Error("Date is Required");
      }

      this.setState({
        dataLog: [],
        loadingButton: true,
      });

      const params = {};

      params.code = filterDocumentType === "VEHICLEBPKB" ? "BPKB" : filterCodeSvb;
      params.document_type = filterDocumentType;
      params.date = dayjs(filterDate).format("YYYY-MM-DD");

      if (filterEngineNumber !== "") {
        params.vehicle_engine_number = filterEngineNumber;
      }

      const dataLog = await miscservices.getMultiUploadNoticeLog(params);
      console.log(dataLog);

      this.setState({
        dataLog: dataLog.data.data,
        loadingButton: false,
      });
    } catch (error) {
      this.setState({
        dataLog: [],
        loadingButton: false,
      });
      Modal.error({
        title: "Validation Error",
        content: error.message || "Error Server",
      });
      return false;
    }
  };

  render() {
    const { filterDate: date, filterEngineNumber, filterDocumentType, dataLog, loadingButton } = this.state;

    const columns = [
      {
        title: "Waktu",
        dataIndex: "time",
        key: "time",
        width: 100,
        sorter: (a, b) => dayjs(a.time, "HH:mm").valueOf() - dayjs(b.time, "HH:mm").valueOf(),
        defaultSortOrder: "descend",
      },
      {
        title: "Nomor Mesin",
        dataIndex: "key",
        key: "key",
        width: 100,
      },
      {
        title: "Keterangan",
        dataIndex: "desc",
        key: "desc",
        width: 200,
      },
    ];

    return (
      <React.Fragment>
        <MainLayout defaultOpenKeys={["7dokumen", "8notice"]} defaultSelectedKeys={["11logmultiupload"]}>
          <div style={{ padding: 10, margin: 10, background: "#FFF" }}>
            <Form name="form-filter" layout="vertical" style={{ padding: 8 }}>
              <Row>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 180 }}>
                  <Form.Item label="Tipe Dokumen">
                    <Select value={filterDocumentType} onChange={this.handleDocumentTypeChange} style={{ minWidth: 180 }}>
                      <Option value="VEHICLETAXNOTICE">Notice</Option>
                      <Option value="VEHICLEBPKB">BPKB</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <Form.Item label="Tanggal Upload">
                    <DatePicker placeholder="Pilih Tanggal" value={date} onChange={this.handleDateChange} />
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <Form.Item label="Nomor Mesin">
                    <Input placeholder="Nomor Mesin (opsional)" value={filterEngineNumber} onChange={this.handleEngineChange} allowClear />
                  </Form.Item>
                </Col>
                <Col style={{ paddingLeft: 2, paddingRight: 2, minWidth: 150 }}>
                  <Form.Item label="&nbsp;">
                    <Button type="primary" onClick={this.fetchDataLog} loading={loadingButton} style={{ minWidth: "50%", background: "#1784b8", borderColor: "#1784b8" }}>
                      Cari Data
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col style={{ paddingLeft: 5, paddingRight: 5 }} xs={{ span: 24 }} xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }}>
                  <Table columns={columns} scroll={{ x: 400 }} dataSource={dataLog.filter((item) => !item.hidden)} pagination={false} loading={loadingButton} rowKey={(record, index) => `${record.key}-${index}`} size={"small"} style={{ marginTop: 20, fontSize: "10%" }} />
                </Col>
              </Row>
            </Form>
          </div>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(LogAnalizedNoticeViewer);
